import { useState, useEffect } from "react";
import newRequest from "../../../../utils/newRequest";
import CustomSnakebar from "../../../../utils/CustomSnakebar";
import { useTranslation } from "react-i18next";

const AddFaqs = ({ isVisible, setVisibility, refreshBrandData }) => {
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [Title, setTitle] = useState("");
  const [title_ar, setTitle_ar] = useState("");
  const [Description, setDescription] = useState("");
  const [description_ar, setDescription_ar] = useState("");

  const handleCloseCreatePopup = () => {
    setVisibility(false);
  };
  const { t, i18n } = useTranslation();

  const handleAddCompany = async () => {
    try {
      const response = await newRequest.post("/creatfaqs", {
        title: Title,
        title_ar: title_ar,
        description: Description,
        description_ar: description_ar,
        status: 1,
      });
      setMessage(`${t("Faqs")} ${Title} ${t("has been added successfully")}.`);
      console.log(response.data);
      refreshBrandData();
      handleCloseCreatePopup();
    } catch (error) {
      setError(error?.response?.data?.error || "Error");
    }
  };

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  return (
    <div>
      {message && (
        <CustomSnakebar
          message={message}
          severity="success"
          onClose={resetSnakeBarMessages}
        />
      )}
      {error && (
        <CustomSnakebar
          message={error}
          severity="error"
          onClose={resetSnakeBarMessages}
        />
      )}
      {/* create the post api popup */}
      {isVisible && (
        <div className="popup-overlay z-50">
          <div className="popup-container h-auto sm:w-[45%] w-full">
            <div
              className="popup-form w-full "
              style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
              <form className="w-full">
                <h2
                  className={`text-secondary font-sans font-semibold text-2xl ${
                    i18n.language === "ar" ? "text-end" : "text-start"
                  }`}
                >
                  {t("Add")} {t("Faqs")}{" "}
                </h2>
                <div className="flex flex-col sm:gap-3 gap-3 mt-5">
                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="title"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Title")}
                    </label>
                    <input
                      type="text"
                      id="title"
                      value={Title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Title")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Title_ar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Title Arabic")}
                    </label>
                    <input
                      type="text"
                      id="Title_ar"
                      value={title_ar}
                      onChange={(e) => setTitle_ar(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Title Arabic")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="description"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Description")}
                    </label>
                    <textarea
                      type="text"
                      id="description"
                      value={Description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder={`${t("Enter")}${t("Description")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="descriptionar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Description Arabic")}
                    </label>
                    <textarea
                      type="text"
                      id="descriptionar"
                      value={description_ar}
                      onChange={(e) => setDescription_ar(e.target.value)}
                      placeholder={`${t("Enter")}${t("Description Arabic")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                </div>

                <div className="w-full flex justify-center items-center gap-8 mt-5">
                  <button
                    type="button"
                    className="px-5 py-2 w-[30%] rounded-sm bg-primary text-white font-body text-sm"
                    onClick={handleCloseCreatePopup}
                  >
                    {t("Close")}
                  </button>
                  <button
                    type="button"
                    onClick={handleAddCompany}
                    className="px-5 py-2 rounded-sm w-[70%] bg-secondary text-white font-body text-sm ml-2"
                  >
                    {t("Add")} {t("Faqs")}
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddFaqs;
